<template>
    <div>
        <el-breadcrumb separator="/" style="margin-bottom: 20px">
            <el-breadcrumb-item :to="{ path: '/main/dashboard' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>微信设置</el-breadcrumb-item>
            <el-breadcrumb-item>体检须知</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form style="max-width: 600px;margin:0 auto" :model="form" ref="form" label-width="100px" class="form">
            <el-form-item align="center">
                <h3>体检须知</h3>
            </el-form-item>
            <el-form-item>
                <el-input type="textarea" v-model="form.content" :rows="15"></el-input>
            </el-form-item>
            <el-form-item align="center">
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    content: ''
                }
            }
        },
        methods: {
            async submitForm() {
                const resp = await this.$http.post(`/mingde/wechat/notice`, this.form)
                if (resp.data.code == 200) {
                    this.$message.success("保存成功")
                }
            },
            async getData() {
                const resp = await this.$http.get(`/mingde/wechat/notice`)
                this.form = resp.data.data
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>

